// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__DBnYp","outline":"button_outline__XVjJ0","large":"button_large__aheMp","small":"button_small__RY9pb"};